
import React from 'react';
import { TableCell } from '@/components/ui/table';
import { Attendee } from '@/types/attendee';

interface CodeCellProps {
  attendee: Attendee;
  isMobile: boolean;
}

export const CodeCell: React.FC<CodeCellProps> = ({ attendee, isMobile }) => {
  // Ensure we display the full 6-character code in the UI
  // If for some reason the code is shorter, we don't modify it here, 
  // as the fix should happen when generating/storing codes
  return (
    <TableCell className={`font-mono text-xs text-slate-500 dark:text-slate-400 ${isMobile ? 'pl-2 pr-1 py-2' : ''}`}>
      {attendee.code}
    </TableCell>
  );
};
